import { MessagesService } from '../../../../services/messages.service';
import { ActionSheetController, LoadingController } from '@ionic/angular';
import { IssuesOrderOwner, IssuesFilterOwner, IssueOrderOwnerType,
         QuproServiceError,
         DocumentReport} from '@arpada/arp-lib-common-qupro';
import { PortalPropietarioService } from '../../../../services/portal-propietario.service';
import { Component, Input, OnInit } from '@angular/core';
import { ActionsSharedData } from '../actions.shared.data';
import { UiService } from '../../../../services/ui.service';

@Component({
    selector: 'more-actions-issues',
    templateUrl: './more-actions-issues.component.html',
    styleUrls: ['./more-actions-issues.component.scss'],
  })
export class ActionsIssuesMoreActionsComponent implements OnInit {

    @Input() filter: IssuesFilterOwner = new IssuesFilterOwner();
    @Input() order: IssuesOrderOwner = new IssuesOrderOwner(IssueOrderOwnerType.DEFAULT_ORDER);
    @Input() sharedData: ActionsSharedData = new ActionsSharedData();

    private loadingWidget: HTMLIonLoadingElement = null;
    private resolveActionSheetActionSelected: (toResolve: boolean) => void;
    private rejectActionSheetActionSelected: (toReject: boolean) => void;
    private readonly actionSheetPromiseExecutor =
        (resolveFun: (toResolve: boolean) => void, rejectFun: (toReject: boolean) => void) => {
            this.resolveActionSheetActionSelected = resolveFun;
            this.rejectActionSheetActionSelected = rejectFun;
        }

    constructor(
        private messagesService: MessagesService,
        private actionSheetController: ActionSheetController,
        private portalPropietarioService: PortalPropietarioService,
        private uiService: UiService,
        private loadingController: LoadingController,
    ) {}

    async ngOnInit() {
        this.loadingWidget = await this.loadingController.create({
            message: this.messagesService.getLoadingActionMessage(),
            duration: 0,
            backdropDismiss: false,
            showBackdrop: true,
        });
        this.closeLoading();
        this.loadingWidget.present();
    }

    openActions() {
        this.presentActionSheet();
    }

    async presentActionSheet(): Promise<HTMLIonActionSheetElement> {
        const actionSheetPromise: Promise<HTMLIonActionSheetElement> = this.actionSheetController.create({
            header: this.messagesService.getMoreActionsActionSheetHeader(),
            buttons: [
                {
                    text: this.messagesService.getMoreActionsIssuesDownloadPdfText(),
                    icon: 'download',
                    handler: this.downloadPdfPressed,
                },
                {
                    text: this.messagesService.getMoreActionsIssuesCloseText(),
                    icon: 'close',
                    role: 'cancel',
                },
            ]
        });
        const actionSheet: HTMLIonActionSheetElement = await actionSheetPromise;
        actionSheet.present();
        return actionSheetPromise;
    }

    downloadPdfPressed = (): Promise<boolean> => {
        this.showLoading();
        this.portalPropietarioService.getIssuesPdfBase64(this.filter, this.order).subscribe((documentReport: DocumentReport) => {
            this.uiService.completeDownloadAction(documentReport.document_name, documentReport.document_mime,
                                                  documentReport.document, 'MoreActionsIssues.downloadIssuesPDF')
                .then(() => {
                    this.resolveActionSheetActionSelected(true);
                }).catch(() => {
                    this.resolveActionSheetActionSelected(false);
                }).finally(() => {
                    this.closeLoading();
                });
        }, (error: QuproServiceError) => {
            this.uiService.showErrorFromServiceErrorOnDownload(error, 'MoreActionsIssues.downloadIssuesPDF');
            this.resolveActionSheetActionSelected(false);
            this.closeLoading();
        });
        return new Promise<boolean>(this.actionSheetPromiseExecutor);
    }

    private showLoading() {
        this.loadingWidget.hidden = false;
    }

    private closeLoading() {
        this.loadingWidget.hidden = true;
    }
}
